import { QueryIntent } from '../../constants';
import { NLPSearchJSONResultFormat, type NLPSearchJSONResultType, type NLPSearchPersonResultType, type NLPSearchTeamResultType, type NLPSearchWhoResultType, type NLPSearchWorkResultType } from '../types';

export const getTypedJSONResultData = ({
	answerString,
	smartAnswersRoute,
}: {
	answerString: string;
	smartAnswersRoute?: QueryIntent;
}): {
	parsedResult: NLPSearchJSONResultType;
	parsedType: NLPSearchJSONResultFormat | undefined;
} => {
	const parsed: NLPSearchJSONResultType = JSON.parse(answerString);

	if ('user_metadata' in parsed && !!parsed.user_metadata) {
		return {
			parsedResult: parsed.user_metadata as NLPSearchWhoResultType['user_metadata'],
			parsedType: NLPSearchJSONResultFormat.WHO,
		};
	} else if ('user_metadata_only_cards' in parsed && !!parsed.user_metadata_only_cards) {
		return {
			parsedResult:
				parsed.user_metadata_only_cards as NLPSearchPersonResultType['user_metadata_only_cards'],
			parsedType: NLPSearchJSONResultFormat.PERSON,
		};
	} else if ('user_metadata_with_activity' in parsed && !!parsed.user_metadata_with_activity) {
		return {
			parsedResult:
				parsed.user_metadata_with_activity as NLPSearchWorkResultType['user_metadata_with_activity'],
			parsedType: NLPSearchJSONResultFormat.WORK,
		};
	} else if ('team_metadata' in parsed && !!parsed.team_metadata) {
		return {
			parsedResult: parsed.team_metadata as NLPSearchTeamResultType['team_metadata'],
			parsedType: NLPSearchJSONResultFormat.TEAM,
		};
	} else if (
		Array.isArray(parsed) &&
		parsed.length > 0 &&
		smartAnswersRoute === QueryIntent.AGENT
	) {
		return {
			parsedResult: parsed,
			parsedType: NLPSearchJSONResultFormat.AGENT,
		};
	} else {
		// This line should never be reached, this means that an unsupported type was in the JSON result
		return { parsedResult: parsed, parsedType: undefined };
	}
};
